import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, IconButton, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AccountCircle, Home, Description, Event, Business, Dashboard as DashboardIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import LanguageToggle from '../../LanguageToggle/LanguageToggle';

const ConsultantNavbar = () => {
    const [userAnchorEl, setUserAnchorEl] = useState(null);
    const navigate = useNavigate();
    const { profileName, roleNames } = useSelector(state => state.auth.user);

    const handleProfileMenuClick = (event) => {
        setUserAnchorEl(event.currentTarget);
    };

    const handleProfileMenuClose = () => {
        setUserAnchorEl(null);
    };

    return (
        <AppBar position="static" sx={{ 
            bgcolor: '#ffffff', 
            color: '#1a1a1a',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
            borderBottom: '1px solid #eee'
        }}>
            <Toolbar sx={{ gap: 2, px: { xs: 2, md: 4 } }}>
                <Typography
                    variant="h6"
                    sx={{ 
                        flexGrow: 1, 
                        cursor: 'pointer', 
                        fontWeight: 900, 
                        letterSpacing: -1,
                        color: '#2D3E50',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                    onClick={() => navigate('/dashboard?view=consultant')}
                >
                    <DashboardIcon sx={{ color: '#2D3E50' }} />
                    CONSULTANT PANEL
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Button 
                        sx={{ color: '#666', fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' } }}
                        onClick={() => navigate('/dashboard/consultant/employer-inquiries')}
                        startIcon={<Business />}
                    >
                        Employers
                    </Button>

                    <Button 
                        sx={{ color: '#666', fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' } }} 
                        onClick={() => navigate('/')} 
                        startIcon={<Home />}
                    >
                        Home
                    </Button>

                    <Button 
                        sx={{ color: '#666', fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' } }} 
                        onClick={() => navigate('/dashboard/consultant/submissions')} 
                        startIcon={<Description />}
                    >
                        Submissions
                    </Button>

                    <Button 
                        sx={{ color: '#666', fontWeight: 600, textTransform: 'none', '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' } }} 
                        onClick={() => navigate('/dashboard/consultant/consultations')} 
                        startIcon={<Event />}
                    >
                        Consultations
                    </Button>
                </Box>

                <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <LanguageToggle />
                    
                    <Box sx={{ width: '1px', height: '24px', bgcolor: '#eee', mx: 1 }} />

                    <IconButton
                        onClick={handleProfileMenuClick}
                        sx={{ 
                            bgcolor: '#f5f7f8',
                            '&:hover': { bgcolor: '#eef1f3' }
                        }}
                    >
                        <AccountCircle />
                    </IconButton>
                </Box>

                <Menu
                    anchorEl={userAnchorEl}
                    open={Boolean(userAnchorEl)}
                    onClose={handleProfileMenuClose}
                    PaperProps={{
                        sx: {
                            mt: 1.5,
                            borderRadius: 2,
                            minWidth: 180,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                            border: '1px solid #eee'
                        }
                    }}
                >
                    <MenuItem disabled sx={{ opacity: 1, py: 1.5 }}>
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#2D3E50' }}>
                                {profileName || "Consultant"}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                Consultant Access
                            </Typography>
                        </Box>
                    </MenuItem>
                    
                    <Box sx={{ height: '1px', bgcolor: '#eee', my: 1 }} />

                    {/* Quick switch to Admin if user has role */}
                    {roleNames?.some(r => r.toUpperCase() === "ADMIN" || r.toUpperCase() === "ADMIN_DEVELOPER") && (
                        <MenuItem onClick={() => navigate('/dashboard?view=admin')} sx={{ py: 1.2 }}>
                            Switch to Admin View
                        </MenuItem>
                    )}

                    <MenuItem onClick={() => navigate('/logout')} sx={{ py: 1.2, color: 'error.main' }}>
                        Logout
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default ConsultantNavbar;
